import React from 'react'
import { find, isEmpty, map } from 'lodash'

import { TextField } from '~/components'

import { getRefineAttributes, getVariantAttributes } from '../get-variants-attributes'

import { Container } from './elements'

const sizesOrder = {
  xs: 1,
  s: 2,
  m: 3,
  l: 4,
  xl: 5,
  xxl: 6,
  '2xl': 6,
  xxxl: 7,
  '3xl': 7,
  xxxxl: 8,
  '4xl': 8,
}

class VariantSelector extends React.Component {
  state = this.getInitialState()

  getInitialState() {
    const { fallbackProduct, activeVariant } = this.props

    const selectedAttributes = activeVariant ? getRefineAttributes(activeVariant) : getRefineAttributes(fallbackProduct)

    return { selectedAttributes }
  }

  componentDidUpdate(prevProps) {
    const { fallbackProduct: prevFallbackProduct } = prevProps

    const { fallbackProduct, activeVariant } = this.props

    const isSameProduct = prevFallbackProduct.slug === fallbackProduct.slug

    if (!isEmpty(activeVariant) && !isSameProduct) {
      this.setState({
        selectedAttributes: getRefineAttributes(activeVariant),
      })
    }
  }

  findAndNotifyChange = () => {
    const { variants, onChange, fallbackProduct } = this.props

    const { selectedAttributes } = this.state

    const allProducts = [fallbackProduct, ...(variants || [])]

    const matchProduct = find(allProducts, product => {
      if (!product?.attributes) return false

      return product.attributes.every(attr => {
        return selectedAttributes[attr.name] === attr.value
      })
    })

    onChange(matchProduct)
  }

  onAttributeSelectedChange = e => {
    const {
      target: { name, value },
    } = e

    this.setState(prevState => {
      return {
        selectedAttributes: {
          ...prevState.selectedAttributes,
          [name]: value,
        },
      }
    }, this.findAndNotifyChange)
  }

  renderContent = () => {
    const { fallbackProduct, variants } = this.props

    const { selectedAttributes } = this.state

    const variantsAttributes = getVariantAttributes(variants, fallbackProduct)

    const renderAttributeField = (values, name) => {
      const renderOption = value => {
        return (
          <option value={value} key={value}>
            {value}
          </option>
        )
      }

      return (
        <TextField
          key={`attribute-${name}`}
          name={name}
          label={name}
          as="select"
          standalone
          value={selectedAttributes[name]}
          onChange={this.onAttributeSelectedChange}
        >
          {map(values, renderOption)}
        </TextField>
      )
    }

    return map(variantsAttributes, (values, name) => {
      // NOTE: This is a one-time fix, if you need more than this one, please immplement a long-term solution
      if (name.toLowerCase() === 'talla') {
        const orderedValues = [...values].sort(
          (a, b) => (sizesOrder[a.toLowerCase()] ?? 0) - (sizesOrder[b.toLowerCase()] ?? 0),
        )

        return renderAttributeField(orderedValues, name)
      }

      return renderAttributeField(values, name)
    })
  }

  render() {
    const { style, className } = this.props

    return (
      <Container style={style} className={className}>
        {this.renderContent()}
      </Container>
    )
  }
}
export default VariantSelector
